jPar.wdk = jPar.wdk || {};
deepMerge(true, jPar.wdk, {
	buttonWithLottie: {
		show: function (clickedElement) {
			clickedElement.querySelector('.wdk-icon').classList.add('noDisplay');
			clickedElement.querySelector('wdk-lottie-animation').classList.remove('noDisplay');
			clickedElement.querySelector('wdk-lottie-animation').myAnimation?.play();
			clickedElement.querySelector('wdk-lottie-animation').myAnimation?.addEventListener('complete', () => {
				clickedElement.querySelector('.wdk-icon').classList.remove('noDisplay');
				window.setTimeout(() => {
					clickedElement.querySelector('wdk-lottie-animation').classList.add('noDisplay');
					clickedElement.querySelector('wdk-lottie-animation').myAnimation?.stop();
				}, 200);
			});
		},

		showIfPossible: function (clickedElement) {
			if (clickedElement.classList.contains('t-lottieAnimation')) {
				this.show(clickedElement);
			}
		},
	},
});
